import React, { CSSProperties } from 'react';

import { Grid2 as Grid, styled } from '@mui/material';

import { ResponsiveGrid } from '@mewa/ui';

export const ContentArea = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<{
    headline: string;
    className?: string;
    style?: CSSProperties;
  }>
>(({ children, headline, className = '', style }, ref) => (
  <div
    ref={ref}
    className={className}
    style={{
      ...style,
      backgroundColor: 'var(--color-light-grey)',
      padding: 'var(--spacer-xxxl) 0',
    }}
  >
    <ResponsiveGrid>
      <Grid size={12}>
        <Headline>{headline}</Headline>
      </Grid>
      <Grid size={12}>{children}</Grid>
    </ResponsiveGrid>
  </div>
));

const Headline = styled('h2')(({ theme }) => ({
  ...theme.typography.h2,
  textAlign: 'center',
  margin: '0 0 var(--spacer-l) 0',
}));
